export default __webpack_public_path__ + "static/media/yt.ba7edcc9.svg";